module.exports = __webpack_public_path__ + "img/ring_memoires@2x.63d3438.webp";